import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

document.addEventListener('DOMContentLoaded', () => {

  const container = document.querySelector('.label-left-text-right-with-animation__inner');
  if (!container) return;

  const textBlock = container.querySelector('.label-left-text-right-with-animation__text');
  if (!textBlock) return;

  const paragraphs = Array.from(textBlock.children);
  if (!paragraphs.length) return;

  // Wrap words in spans
  function wrapWords(el) {
    const text = el.textContent || '';
    const tokens = text.split(/(\s+)/);
    const frag = document.createDocumentFragment();
    tokens.forEach(tok => {
      if (!tok) return;
      const span = document.createElement('span');
      span.className = /^\s+$/.test(tok) ? 'space' : 'word';
      span.textContent = tok;
      frag.appendChild(span);
    });
    el.innerHTML = '';
    el.appendChild(frag);
  }

  paragraphs.forEach(p => wrapWords(p));

  const allWords = paragraphs.flatMap(p => Array.from(p.querySelectorAll('.word')));
  gsap.set(allWords, { opacity: 0.35 });

  function createScrollTrigger() {
    const blockHeight = textBlock.offsetHeight;
    const screenHeight = window.innerHeight;

    const scrollDistance = blockHeight + screenHeight * 0.5; 
    const fillOffset = 0.85; // 85% прогресу скролу = 100% заповнення слів

    return ScrollTrigger.create({
      trigger: textBlock,
      start: 'top bottom',
      end: `+=${scrollDistance}`,
      scrub: 1.2,
      onUpdate: self => {
        // прогрес зі зсувом fillOffset
        const rawProgress = clamp(self.progress / fillOffset, 0, 1);
        const visibleCount = Math.floor(allWords.length * rawProgress);

        allWords.forEach((w, i) => {
          w.style.opacity = i < visibleCount ? '1' : '0.35';
        });
      }
    });
  }

  let st = createScrollTrigger();

  window.addEventListener('resize', () => {
    if (st) st.kill();
    st = createScrollTrigger();
    ScrollTrigger.refresh();
  });

});

document.addEventListener('DOMContentLoaded', () => {
  // collect all containers
  const containers = Array.from(document.querySelectorAll('.js-scroll-filling-text-animation-simple'));
  if (!containers.length) return;

  // helper: wrap words into spans
  function wrapWords(el) {
    // split into words and spaces, preserve spaces
    const text = el.textContent || '';
    const tokens = text.split(/(\s+)/);
    const frag = document.createDocumentFragment();

    tokens.forEach(tok => {
      const span = document.createElement('span');
      if (/^\s+$/.test(tok)) {
        span.className = 'space';
      } else if (tok.length === 0) {
        return;
      } else {
        span.className = 'word';
      }
      span.textContent = tok;
      frag.appendChild(span);
    });

    el.innerHTML = '';
    el.appendChild(frag);
  }

  // build blocks: one entry per container, each with flat words array
  const blocks = containers.map(container => {
    let children = Array.from(container.querySelectorAll(':scope > *'));
    if (children.length === 0) children = [container];

    // wrap words inside each child
    children.forEach(child => wrapWords(child));

    // collect words across all children in document order
    const words = children.flatMap(ch => Array.from(ch.querySelectorAll('.word')));

    return { container, children, words };
  });

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  // animation loop throttle
  let ticking = false;
  function requestUpdate() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateAll();
        ticking = false;
      });
      ticking = true;
    }
  }

  function updateAll() {
    const vh = window.innerHeight;
    const defaultOffsetStart = 0;
    const defaultOffsetEnd = 0.4;

    blocks.forEach(block => {
      const { container, words } = block;
      if (!words.length) return;

      const rect = container.getBoundingClientRect();
      const totalScrollDistance = vh + rect.height;
      const scrolled = vh - rect.top; // how much we've progressed through the "journey"
      let progress = scrolled / totalScrollDistance;

      // read per-container offsets if provided via data attributes
      let offsetStart = parseFloat(container.dataset.offsetStart);
      if (isNaN(offsetStart)) offsetStart = defaultOffsetStart;
      let offsetEnd = parseFloat(container.dataset.offsetEnd);
      if (isNaN(offsetEnd)) offsetEnd = defaultOffsetEnd;
      // guard: ensure sensible values
      if (offsetEnd <= offsetStart) {
        offsetStart = defaultOffsetStart;
        offsetEnd = defaultOffsetEnd;
      }

      // normalize progress into [0..1] within offset window
      progress = (progress - offsetStart) / (offsetEnd - offsetStart);
      progress = clamp(progress, 0, 1);

      const filledCount = Math.round(progress * words.length);

      words.forEach((w, i) => {
        if (i < filledCount) w.classList.add('filled');
        else w.classList.remove('filled');
      });
    });
  }

  // initial run
  updateAll();

  // listeners
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
});
